/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CampaignDTO,
  CampaignFromTemplateRequest,
  CampaignRequest,
  CampaignStrategyPatchRequest,
  CampaignSummaryDTO,
  CreateCampaignFromMondayTemplatesPathParameters,
  CreateCampaignFromTemplatePathParameters,
  CreateCampaignPathParameters,
  DeleteCampaignPathParameters,
  GetAllCampaignsForClientParams,
  GetAllCampaignsForClientPathParameters,
  GetAvailableMondayStrategiesParams,
  GetAvailableMondayStrategiesPathParameters,
  GetBatchJobStatesPathParameters,
  GetCampaignPathParameters,
  GetProgramTemplatesCampaignIdPathParameters,
  GetUsedCampaignTemplateIdsPathParameters,
  MondayBatchJobStatesDTO,
  MondayCampaignRequest,
  MondayGroupDTO,
  PagedModelCampaignSummaryDTO,
  PartiallyUpdateTemplatedCampaignPathParameters,
  UpdateCampaignPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getCampaign = () => {
  /**
 * Get Campaign

Required authority: PERM_CAMPAIGN_READ
 */
  const getCampaign = ({ clientId, id }: GetCampaignPathParameters) => {
    return customInstance<CampaignDTO>({
      url: `/api/clients/${clientId}/campaigns/${id}`,
      method: "GET",
    });
  };
  /**
 * Update a campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const updateCampaign = (
    { clientId, id }: UpdateCampaignPathParameters,
    campaignRequest: CampaignRequest,
  ) => {
    return customInstance<CampaignSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: campaignRequest,
    });
  };
  /**
 * Delete a campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const deleteCampaign = ({ clientId, id }: DeleteCampaignPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${id}`,
      method: "DELETE",
    });
  };
  /**
 * Partially update a templated campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const partiallyUpdateTemplatedCampaign = (
    { clientId, id }: PartiallyUpdateTemplatedCampaignPathParameters,
    campaignStrategyPatchRequest: CampaignStrategyPatchRequest,
  ) => {
    return customInstance<CampaignDTO>({
      url: `/api/clients/${clientId}/campaigns/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: campaignStrategyPatchRequest,
    });
  };
  /**
 * Get all campaigns for client

Required authority: PERM_CAMPAIGN_READ
 */
  const getAllCampaignsForClient = (
    { clientId }: GetAllCampaignsForClientPathParameters,
    params?: GetAllCampaignsForClientParams,
  ) => {
    return customInstance<PagedModelCampaignSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a campaign. If touchpointTemplates are provided, touchpoints and initial versions will be created from templates

Required authority: PERM_CAMPAIGN_WRITE
 */
  const createCampaign = (
    { clientId }: CreateCampaignPathParameters,
    campaignRequest: CampaignRequest,
  ) => {
    return customInstance<CampaignSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: campaignRequest,
    });
  };
  /**
 * Create a campaign from a campaign template

Required authority: PERM_CAMPAIGN_WRITE
 */
  const createCampaignFromTemplate = (
    { clientId }: CreateCampaignFromTemplatePathParameters,
    campaignFromTemplateRequest: CampaignFromTemplateRequest,
  ) => {
    return customInstance<CampaignDTO>({
      url: `/api/clients/${clientId}/campaigns/from-template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: campaignFromTemplateRequest,
    });
  };
  /**
 * Create a campaign. If touchpointTemplates are provided, touchpoints and initial versions will be created from templates

Required authority: PERM_CAMPAIGN_WRITE
 */
  const createCampaignFromMondayTemplates = (
    { clientId }: CreateCampaignFromMondayTemplatesPathParameters,
    mondayCampaignRequest: MondayCampaignRequest,
  ) => {
    return customInstance<CampaignSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns/from-strategy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mondayCampaignRequest,
    });
  };
  /**
 * Get campaign template IDs that are already used in this campaign

Required authority: PERM_CAMPAIGN_READ
 */
  const getUsedCampaignTemplateIds = ({
    clientId,
    id,
  }: GetUsedCampaignTemplateIdsPathParameters) => {
    return customInstance<string[]>({
      url: `/api/clients/${clientId}/campaigns/${id}/used-campaign-template-ids`,
      method: "GET",
    });
  };
  /**
 * Get available strategies for a campaign based on its objective and the supplied population type

Required authority: PERM_CAMPAIGN_READ
 */
  const getAvailableMondayStrategies = (
    { clientId, id }: GetAvailableMondayStrategiesPathParameters,
    params?: GetAvailableMondayStrategiesParams,
  ) => {
    return customInstance<MondayGroupDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${id}/strategies`,
      method: "GET",
      params,
    });
  };
  /**
 * List touchpoint sync jobs and their status

Required authority: PERM_SUPER_ADMIN
 */
  const getBatchJobStates = ({ clientId, id }: GetBatchJobStatesPathParameters) => {
    return customInstance<MondayBatchJobStatesDTO>({
      url: `/api/clients/${clientId}/campaigns/${id}/job-states`,
      method: "GET",
    });
  };
  /**
 * Get Program Templates campaign ID

Required authority: PERM_CAMPAIGN_READ
 */
  const getProgramTemplatesCampaignId = ({
    clientId,
  }: GetProgramTemplatesCampaignIdPathParameters) => {
    return customInstance<string>({
      url: `/api/clients/${clientId}/campaigns/program-templates/id`,
      method: "GET",
    });
  };
  return {
    getCampaign,
    updateCampaign,
    deleteCampaign,
    partiallyUpdateTemplatedCampaign,
    getAllCampaignsForClient,
    createCampaign,
    createCampaignFromTemplate,
    createCampaignFromMondayTemplates,
    getUsedCampaignTemplateIds,
    getAvailableMondayStrategies,
    getBatchJobStates,
    getProgramTemplatesCampaignId,
  };
};
export type GetCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getCampaign"]>>
>;
export type UpdateCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["updateCampaign"]>>
>;
export type DeleteCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["deleteCampaign"]>>
>;
export type PartiallyUpdateTemplatedCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["partiallyUpdateTemplatedCampaign"]>>
>;
export type GetAllCampaignsForClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getAllCampaignsForClient"]>>
>;
export type CreateCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["createCampaign"]>>
>;
export type CreateCampaignFromTemplateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["createCampaignFromTemplate"]>>
>;
export type CreateCampaignFromMondayTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["createCampaignFromMondayTemplates"]>>
>;
export type GetUsedCampaignTemplateIdsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getUsedCampaignTemplateIds"]>>
>;
export type GetAvailableMondayStrategiesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getAvailableMondayStrategies"]>>
>;
export type GetBatchJobStatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getBatchJobStates"]>>
>;
export type GetProgramTemplatesCampaignIdResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaign>["getProgramTemplatesCampaignId"]>>
>;
